<div mat-dialog-title>Add a Certificated Outlet</div>
<div mat-dialog-content>
  <form >
    <mat-form-field>
      <mat-label>Organization</mat-label>
      <input matInput [matAutocomplete]="complete" [formControl]="orgSearch">
      @if (addCertificatedOutletService.loading$ | async) {
        <mat-spinner mode="indeterminate" diameter="16" matSuffix></mat-spinner>
      }
      @if ((orgSearch.value !== null) && !(addCertificatedOutletService.loading$ | async)) {
        <button mat-icon-button matSuffix (click)="orgSearch.setValue(null)" color="warn"><mat-icon>close</mat-icon></button>
      }
      <mat-autocomplete #complete="matAutocomplete" [displayWith]="displayFn">
        @for (org of addCertificatedOutletService.organizations$ | async; track org) {
          <mat-option [value]="org">{{org.name}}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!valid" (click)="save()">Create</button>
</div>
